/******************************************************************
 * Archivo : client/src/components/Admin/surveys/SurveyViewer/ViewerUser/ViewerUserContainer.js
 * Proyecto: CB30
 *
 * Tarjeta de datos personales - Visor Universal.
 ******************************************************************/

import React, { useState } from "react";
import { graphql } from "react-apollo";

import query from "../../../../../queries/fetchViewerUser";

const ViewerUserContainer = props => {

  const [mostrarDatos, setMostrarDatos] = useState(false);

  if (props.data.loading) {
    return <div className="loader">Cargando datos personales...</div>;
  }

  if (props.data.error) {
    return <div>{props.data.error.message}</div>;
  }

  if (!props.data.viewerUser) {
    return null;
  }

  const usuario = props.data.viewerUser;
  const person = usuario.person || {};

  return (
    <div className="card mb-3">

      <div className="card-header d-flex justify-content-between align-items-center">

        <strong>Datos personales</strong>

        <button
          type="button"
          className="btn btn-sm btn-primary"
          onClick={() => setMostrarDatos(!mostrarDatos)}
        >
          {mostrarDatos ? "Ocultar" : "Ver"}
        </button>

      </div>

      {
        mostrarDatos && (

          <div className="card-body">

            <p>
              <strong>Nombre:</strong>{" "}
              {usuario.nombre}
            </p>

            <p>
              <strong>Apellido:</strong>{" "}
              {usuario.apellido}
            </p>

            <p>
              <strong>Correo:</strong>{" "}
              {usuario.email}
            </p>

            <p>
              <strong>Tipo de documento:</strong>{" "}
              {person.tipo_de_documento}
            </p>

            <p>
              <strong>Documento:</strong>{" "}
              {person.documento_de_identidad}
            </p>

            <p>
              <strong>Fecha de nacimiento:</strong>{" "}
              {person.fecha_de_nacimiento}
            </p>

            <p>
              <strong>Género:</strong>{" "}
              {person.genero}
            </p>

            <p>
              <strong>Estado civil:</strong>{" "}
              {person.estado_civil}
            </p>

            <p>
              <strong>Nivel educativo:</strong>{" "}
              {person.nivel_educativo}
            </p>

            <p>
              <strong>Ocupación:</strong>{" "}
              {person.ocupacion}
            </p>

            <p>
              <strong>Dirección:</strong>{" "}
              {person.direccion}
            </p>

            <p>
              <strong>Estrato:</strong>{" "}
              {person.estrato}
            </p>

            <p>
              <strong>Localidad:</strong>{" "}
              {person.localidad}
            </p>

            <p>
              <strong>Departamento:</strong>{" "}
              {person.departamento}
            </p>

            <p>
              <strong>Ciudad:</strong>{" "}
              {person.ciudad}
            </p>

            <p>
              <strong>País de residencia:</strong>{" "}
              {person.pais_de_residencia}
            </p>

            <p>
              <strong>Teléfono:</strong>{" "}
              {person.telefono}
            </p>

            <p>
              <strong>Celular:</strong>{" "}
              {person.celular}
            </p>

            <p>
              <strong>Lugar de nacimiento:</strong>{" "}
              {person.lugar_de_nacimiento}
            </p>

            <p>
              <strong>País de nacimiento:</strong>{" "}
              {person.pais_de_nacimiento}
            </p>

            <p>
              <strong>Lugar de expedición:</strong>{" "}
              {person.lugar_de_expedicion}
            </p>

            <p>
              <strong>Raza:</strong>{" "}
              {person.raza}
            </p>

            <p>
              <strong>Grupo étnico:</strong>{" "}
              {person.grupo_etnico}
            </p>

          </div>

        )
      }

    </div>
  );
};

export default graphql(query, {
  options: props => ({
    variables: {
      id: props.usuarioId
    }
  })
})(ViewerUserContainer);


// WEBPACK FOOTER //
// ./src/components/Admin/surveys/SurveyViewer/ViewerUser/ViewerUserContainer.js